import { css } from 'styled-components';

export const scrollbarStyle = css`
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
    height: 3px;
  }

  ::-webkit-scrollbar-track {
    height: 5px !important;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px !important;
    height: 3px;
    background: #41617d !important;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5) !important;
  }
`;
